import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../layouts/error.vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../assets/scss/fonts/Futura-PT.scss'

import '../assets/scss/index.scss'

import '../node_modules/vue-select/dist/vue-select.css'

import _2d217e9e from '../layouts/auth.vue'
import _2fc28afa from '../layouts/components/Footer/FooterNav/index.vue'
import _45455921 from '../layouts/components/Footer/index.vue'
import _3e0e0994 from '../layouts/components/Header/Bottom/Catalog.vue'
import _44a235a6 from '../layouts/components/Header/Bottom/index.vue'
import _492a55c4 from '../layouts/components/Header/Bottom/Menu.vue'
import _9bb9be66 from '../layouts/components/Header/Bottom/Search.vue'
import _3922eeda from '../layouts/components/Header/index.vue'
import _7d330443 from '../layouts/components/Header/Main/Actions/AccountMenu.vue'
import _2572756e from '../layouts/components/Header/Main/Actions/index.vue'
import _4ca431fb from '../layouts/components/Header/Main/index.vue'
import _21d76dbf from '../layouts/components/Header/Main/Search.vue'
import _56dc2692 from '../layouts/components/Header/MenuToggle.vue'
import _3a1db5e1 from '../layouts/components/Header/MobileMenu/First.vue'
import _3c0cfc23 from '../layouts/components/Header/MobileMenu/index.vue'
import _805bb966 from '../layouts/components/Header/MobileMenu/List.vue'
import _c2e9559a from '../layouts/components/Header/Support/index.vue'
import _c6b1fca0 from '../layouts/components/Header/Top/HeaderTopHelp.vue'
import _0f1929ac from '../layouts/components/Header/Top/HeaderTopLinks.vue'
import _5d4b52b9 from '../layouts/components/Header/Top/index.vue'
import _51b600d8 from '../layouts/components/LocationModal/index.vue'
import _714b4a46 from '../layouts/components/Search/Input.vue'
import _066d62bf from '../layouts/components/Search/Result/Empty.vue'
import _0868f664 from '../layouts/components/Search/Result/index.vue'
import _07497196 from '../layouts/components/Search/Result/Products/index.vue'
import _41e3f870 from '../layouts/components/Search/Result/Products/Item.vue'
import _4decf6e1 from '../layouts/components/Search/Result/Suggestions.vue'
import _6e0726fc from '../layouts/components/Sidebar/index.vue'
import _86a32f50 from '../layouts/components/Sidebar/Menu/index.vue'
import _295e4740 from '../layouts/components/Sidebar/Wrapper/index.vue'
import _6f6c098b from '../layouts/default.vue'
import _27ea919c from '../layouts/errorLayout.vue'
import _03d773c8 from '../layouts/hiddenSidebar.vue'
import _ee7125b0 from '../layouts/simple.vue'

const layouts = { "_auth": sanitizeComponent(_2d217e9e),"_components/Footer/FooterNav/index": sanitizeComponent(_2fc28afa),"_components/Footer/index": sanitizeComponent(_45455921),"_components/Header/Bottom/Catalog": sanitizeComponent(_3e0e0994),"_components/Header/Bottom/index": sanitizeComponent(_44a235a6),"_components/Header/Bottom/Menu": sanitizeComponent(_492a55c4),"_components/Header/Bottom/Search": sanitizeComponent(_9bb9be66),"_components/Header/index": sanitizeComponent(_3922eeda),"_components/Header/Main/Actions/AccountMenu": sanitizeComponent(_7d330443),"_components/Header/Main/Actions/index": sanitizeComponent(_2572756e),"_components/Header/Main/index": sanitizeComponent(_4ca431fb),"_components/Header/Main/Search": sanitizeComponent(_21d76dbf),"_components/Header/MenuToggle": sanitizeComponent(_56dc2692),"_components/Header/MobileMenu/First": sanitizeComponent(_3a1db5e1),"_components/Header/MobileMenu/index": sanitizeComponent(_3c0cfc23),"_components/Header/MobileMenu/List": sanitizeComponent(_805bb966),"_components/Header/Support/index": sanitizeComponent(_c2e9559a),"_components/Header/Top/HeaderTopHelp": sanitizeComponent(_c6b1fca0),"_components/Header/Top/HeaderTopLinks": sanitizeComponent(_0f1929ac),"_components/Header/Top/index": sanitizeComponent(_5d4b52b9),"_components/LocationModal/index": sanitizeComponent(_51b600d8),"_components/Search/Input": sanitizeComponent(_714b4a46),"_components/Search/Result/Empty": sanitizeComponent(_066d62bf),"_components/Search/Result/index": sanitizeComponent(_0868f664),"_components/Search/Result/Products/index": sanitizeComponent(_07497196),"_components/Search/Result/Products/Item": sanitizeComponent(_41e3f870),"_components/Search/Result/Suggestions": sanitizeComponent(_4decf6e1),"_components/Sidebar/index": sanitizeComponent(_6e0726fc),"_components/Sidebar/Menu/index": sanitizeComponent(_86a32f50),"_components/Sidebar/Wrapper/index": sanitizeComponent(_295e4740),"_default": sanitizeComponent(_6f6c098b),"_errorLayout": sanitizeComponent(_27ea919c),"_hiddenSidebar": sanitizeComponent(_03d773c8),"_simple": sanitizeComponent(_ee7125b0) }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map(async (page) => {
        let p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        // Wait for asyncData & old fetch to finish
        await Promise.all(p)
        // Cleanup refs
        p = []

        if (page.$fetch) {
          p.push(page.$fetch())
        }
        // Get all component instance to call $fetch
        for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
          p.push(component.$fetch())
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        this.nuxt.errPageReady = true
        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    },
  },

  components: {
    NuxtLoading
  }
}
